module.exports = __webpack_public_path__ + "img/Photo_3__East_Street__976_243_3.f6e2056e.jpg";